import styled from 'styled-components';
import {getColorFromTheme} from '../../../ui-utils';

export const DropdownWrapper = styled.div`
  position: absolute;
  display: inline-block;
  top: 120%;
  left: 0;
  min-width: 310px;
  border-radius: 8px;
  border: solid 1px ${getColorFromTheme('borderDark')};
  background-color: ${getColorFromTheme('white')};
  box-shadow: ${({theme}) => theme.elevation.level2};
  z-index: 3;
`;

export const DropWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const ArrowIconWrapper = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 6px;

  svg {
    stroke: ${getColorFromTheme('textBody')};
    width: 20px;
    height: 20px;
  }
`;

export const AvatarWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DropdownHandler = styled.button<{
  open: boolean;
  $compact?: boolean;
  $selected?: boolean;
}>`
  outline: none;
  color: ${getColorFromTheme('textDark')};
  width: ${({$compact}) => ($compact ? 'auto' : '100%')};
  display: inline-block;
  min-height: ${({$compact}) => ($compact ? '38px' : 'auto')};
  padding: ${({$compact, $selected}) =>
    $compact ? ($selected ? '7px 0' : '7px 16px') : '0'};
  background-color: ${getColorFromTheme('white')};
  border: ${({$compact, $selected, theme}) =>
    $compact
      ? `1px solid ${$selected ? 'transparent' : theme.colors.borderDark}`
      : 'none'};
  border-radius: ${({$compact}) => ($compact ? '8px' : '0')};
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background-color: ${({$selected, theme}) =>
      $selected ? theme.colors.backgroundDark : theme.colors.white};
    border-color: ${({$compact, $selected, theme}) =>
      $compact && !$selected ? theme.colors.purple300 : 'transparent'};
  }
`;

export const HandlerWrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
